import React, { useState }   from 'react';
import { useRecoilState_TRANSITION_SUPPORT_UNSTABLE, useRecoilValue_TRANSITION_SUPPORT_UNSTABLE, useResetRecoilState, useSetRecoilState } from "recoil";
import ServicePatient from "src/services/patient/patient";
import { cleanRut, emailValidator, formatRut, removeCharactersSpecials, removeLettersAndCharactersSpecials, removeNumbers } from "src/shared/global/helpers";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { historyRouteState } from "src/store/global/historyState";
import { snackbarState } from "src/store/global/snackbarState";
import { activeStepResetPasswordState, completedStepResetPasswordState } from "../recoveryPassword/state/atoms";
import {activeStepDeleteUserState, completedStepDeleteUserState } from "../deleteUser/state/atoms";
import { confirmAccountState, errorsConfirmAccountState } from "../register/state/atoms";
import { activeResendCodeState } from "../resendCodeConfirmation/state/atoms";
import { PatientSchema } from "../schemas/PatientSchema";
import { activeStepRegisterState, resendCodeConfirmationState, completedStepRegisterState, errorsFormRegisterState, valuesFormRegisterState, errorsReservationGuestState, rulesPasswordState } from "../state/atoms";
import useAuthPatient from "./useAuthPatient";
import { useNavigate } from 'react-router-dom' ;

const useSavePatient = () => {
    const { catchErrorApi } = useCatchErrorApi();
    const [loading, setLoading] = useState(false)
    const setActiveResendCode = useSetRecoilState(activeResendCodeState)
    const [valuesFormRegister, setValuesFormRegister] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(valuesFormRegisterState);
    const [errorsFormRegister, setErrorsFormRegister] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(errorsFormRegisterState);
    const [activeStepRegister, setActiveStepRegister] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(activeStepRegisterState);
    const [completedStepRegister, setCompletedStepRegister] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(completedStepRegisterState);
    const { getDetailPatient } = useAuthPatient();

    const [activeStepResetPassword, setActiveStepResetPassword] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(activeStepResetPasswordState);
    const [completedStepResetPassword, setCompletedStepResetPassword] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(completedStepResetPasswordState);

    
    const [activeStepDeleteUser, setActiveStepDeleteUser] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(activeStepDeleteUserState);
    const [completedStepDeleteUser, setCompletedStepDeleteUser] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(completedStepDeleteUserState);
    

    const [resendCodeConfirmation, setResendCodeConfirmation] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(resendCodeConfirmationState);

    const confirmAccount = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(confirmAccountState);
    const setErrorsConfirmAccount = useSetRecoilState(errorsConfirmAccountState);
    const setSnackbar = useSetRecoilState(snackbarState);
    //const historyRoute = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(historyRouteState);
    const navigate = useNavigate();

    const resetrulesPassword = useResetRecoilState(rulesPasswordState);

    const handleNextStep = () => {
        setCompletedStepRegister({
            ...completedStepRegister,
            [activeStepRegister]: true
        })
        setResendCodeConfirmation(false);
        setActiveStepRegister((prevActiveStep) => prevActiveStep + 1)
    }

    const handleBackStep = () => {
        setCompletedStepRegister({
            ...completedStepRegister,
            [activeStepRegister - 1]: true
        })
        setActiveStepRegister((prevActiveStep) => prevActiveStep - 1)
    }

    const handleCompletedStep = () => {
        setCompletedStepRegister({
            ...completedStepRegister,
            [activeStepRegister]: true
        })
    }

    const handleNextStepResetPassword = () => {
        setCompletedStepResetPassword({
            ...completedStepResetPassword,
            [activeStepResetPassword]: true
        })
        setActiveStepResetPassword((prevActiveStep) => prevActiveStep + 1)
    }
   
    const handleNextStepEmailDelete = () => {
        setCompletedStepDeleteUser({
            ...completedStepDeleteUser,
            [activeStepDeleteUser]: true
        })
        setActiveStepDeleteUser((prevActiveStep) => prevActiveStep + 1)
    }

    const handleBackStepEmailDelete = () => {
        setCompletedStepRegister({
            ...completedStepDeleteUser,
            [activeStepDeleteUser]: true
        })
        setActiveStepDeleteUser((prevActiveStep) => prevActiveStep - 1)
    }
       
    const handleCancelUserDelete = () => {
        setCompletedStepDeleteUser({
            ...completedStepDeleteUser,
            [activeStepDeleteUser]: true
        })
        setActiveStepDeleteUser((prevActiveStep) => prevActiveStep + 1)
    }

    const handleCompletedStepResetPassword = () => {
        setCompletedStepResetPassword({
            ...completedStepResetPassword,
            [activeStepResetPassword]: true
        })
    }

    const handleResendCodeConfirmation = async () => {
        try {
            const patientSchema = new PatientSchema();
            let body = { uswRut: valuesFormRegister['uswRut'], uswEmail: valuesFormRegister['uswEmail'] };
            const emailRutValidate = await patientSchema.isValidSchema({ ...body }, true);

            if (emailRutValidate.ok === false) {
                setErrorsFormRegister((currentState) => ({
                    ...currentState,
                    ...emailRutValidate.dataErrors
                }));

                return;
            }
            await ServicePatient.resendCodeConfirmation(body);
            setActiveResendCode(true)
        } catch (error) {
            catchErrorApi(error)
        } finally {
            //setActiveResendCode(false);
        }
    }

    const handleChange = (ev) => {
        let { name, value } = ev.target;
        if (errorsFormRegister.hasOwnProperty(name)) {
            setErrorsFormRegister({ ...errorsFormRegister, [name]: [] });
        }

        if ((name === 'uswFonoMovil' && value !== '')) {
            setErrorsFormRegister({
                ...errorsFormRegister,
                uswFonoMovil: [],
                phoneEmpty: []
            });
        }

        if ((name === 'uswFonoFijo1' && value !== '')) {
            setErrorsFormRegister({
                ...errorsFormRegister,
                phoneEmpty: [],
                uswFonoFijo1: []
            });
        }

        if ((name === 'uswClave' && value !== '') || (name === 'uswRepetirClave' && value !== '')) {
            setErrorsFormRegister({
                ...errorsFormRegister,
                matchPassword: [],
            });
        }

        if (name === 'uswNombres' && value !== '') {
            value = removeNumbers(removeCharactersSpecials(value));
        }

        if (name === 'uswApePat' && value !== '') {
            value = removeNumbers(removeCharactersSpecials(value));
        }

        if (name === 'uswApeMat' && value !== '') {
            value = removeNumbers(removeCharactersSpecials(value));
        }

        if (name === 'uswRut' && value !== '') {
            value = formatRut(cleanRut(value));
        }

        if (name === 'uswFonoMovil' && value !== '') {
            value = removeLettersAndCharactersSpecials(value)
        }

        if (name === 'uswFonoFijo1' && value !== '') {
            value = removeLettersAndCharactersSpecials(value)
        }

        if (name === 'uswEmail' && value !== '') {
            value = emailValidator(value);
        }

        if (name === 'uswEmailConfirm' && value !== '') {
            value = emailValidator(value);
        }

        if (value === undefined || value === '') value = null;

        setValuesFormRegister({
            ...valuesFormRegister,
            [name]: value
        })
    }

    const handleValidateEmails = async () => {
        let findErrors = false;
        let email = valuesFormRegister['uswEmail'];
        let emailConfirm = valuesFormRegister['uswEmailConfirm'];
        
        if (email !== emailConfirm) {
            findErrors = true;
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswEmailConfirm: ["Los correos electrónicos no coinciden"]
            }))
        }
        return findErrors;
    }

    const handleValidatePhones = async () => {
        let findErrors = false;
        // if (valuesFormRegister['uswCodFonoFijo1'] && !valuesFormRegister['uswFonoFijo1']) {
        //     findErrors = true;
        //     setErrorsFormRegister((currentState) => ({
        //         ...currentState,
        //         uswFonoFijo1: ["Por favor indique el fono fijo"],
        //         phoneEmpty: []
        //     }))
        // }

        // if (!valuesFormRegister['uswCodFonoFijo1'] && valuesFormRegister['uswFonoFijo1']) {
        //     findErrors = true;
        //     setErrorsFormRegister((currentState) => ({
        //         ...currentState,
        //         uswCodFonoFijo1: [""],
        //         phoneEmpty: ["Indique el codigo de área"]
        //     }))
        // }

        if (!valuesFormRegister['uswFonoFijo1'] && !valuesFormRegister['uswFonoMovil']) {
            findErrors = true;
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswCodFonoFijo1: [],
                uswFonoFijo1: [],
                uswFonoMovil: [],
                phoneEmpty: ["Por favor indique al menos un teléfono de contacto"]
            }))
        }

        if (valuesFormRegister['uswFonoFijo1'] && valuesFormRegister['uswFonoFijo1'].length < 9) {
            findErrors = true;
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswCodFonoFijo1: [],
                uswFonoFijo1: ["El teléfono fijo debe contener 9 dígitos"],
                uswFonoMovil: [],
                phoneEmpty: []
            }))
        }

        if (valuesFormRegister['uswFonoMovil'] && valuesFormRegister['uswFonoMovil'].length < 9) {
            findErrors = true;
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswCodFonoFijo1: [],
                //uswFonoFijo1: [],
                uswFonoMovil: ["El teléfono móvil debe tener 9 dígitos"],
                phoneEmpty: []
            }))
        }

        if (valuesFormRegister['uswFonoMovil'] && !valuesFormRegister['uswFonoMovil'].startsWith("9")) {
            findErrors = true;
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswCodFonoFijo1: [],
                uswFonoFijo1: currentState.uswFonoFijo1,
                uswFonoMovil: ["El teléfono móvil debe comenzar con un 9"],
                phoneEmpty: []
            }))
        }

        return findErrors;
    }

    const handleValidateInformationPatient = async () => {
        let findErrors = false;
        const patientSchema = new PatientSchema();
        const bodyValidate = await patientSchema.isValidSchema({ ...valuesFormRegister });

        findErrors = await handleValidatePhones()
        findErrors = await handleValidateEmails()

        if (bodyValidate.ok === false) {
            findErrors = true;
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                ...bodyValidate.dataErrors
            }))
        }
        return findErrors;
    }

    const handleClickCompleteInformation = async () => {
        setLoading(true);
        try {
            const errors = await handleValidateInformationPatient();
            if (errors) return;
    
            const validateUser = await handleValidateExistUser();
            if (validateUser) return;
    
            handleNextStep()
            
        } finally {
            setLoading(false)
        }
    }

    const handleValidatePasswordsMatch = () => {
        if (
            (!valuesFormRegister['uswClave'] || !valuesFormRegister['uswRepetirClave']) ||
            (valuesFormRegister['uswClave'] !== valuesFormRegister['uswRepetirClave'])) {
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                matchPassword: ["Las contraseñas no coinciden"]
            }))

            return false;
        } else {
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                matchPassword: []
            }))

            return true
        }
    }

    const handleClickEditPatient = async () => {
        setLoading(true)
        try {
            const errors = await handleValidateInformationPatient();
            if (errors) return;

            let editData = { ...valuesFormRegister };
            delete editData['uswRepetirClave'];
            delete editData['uswClave'];
            delete editData['claveTemporal'];
            delete editData['idgDescrip'];
            delete editData['isaNombre'];
            delete editData['uswFonoFijo2']

            await ServicePatient.editPatient(valuesFormRegister['uswRut'], editData);
            await getDetailPatient();

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Sus datos han sido modificados correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false)
        }
    }

    const handleValidateExistUser = async () => {
        const existsRut = await ServicePatient.existsUser(valuesFormRegister['uswRut']);
        const existsEmail = await ServicePatient.existsUser(valuesFormRegister['uswEmail']);
        if (existsRut) {
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswRut: ["El rut ya está registrado"]
            }))
        }

        if (existsEmail) {
            setErrorsFormRegister((currentState) => ({
                ...currentState,
                uswEmail: ["El correo electrónico ya está registrado"]
            }))
        }

        if (existsRut == true) {
            const accountVerified = await ServicePatient.getAccountVerified(valuesFormRegister['uswRut']);
            console.warn("accountVerified => ", accountVerified);
            setResendCodeConfirmation(accountVerified);
        }else{
            setResendCodeConfirmation(false);
        }

        if (existsRut || existsEmail) return true;
        return false;
    }

    const handleClickSavePatient = async () => {
        setLoading(true);
        try {
            if (!handleValidatePasswordsMatch()) return;
            await ServicePatient.savePatient({ ...valuesFormRegister })
            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Su cuenta ha sido creada correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            handleNextStep()

        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false);
        }
    }

    const handleClickConfirmAccount = async () => {
        setLoading(true);
        try {
            if (Object.values(confirmAccount).some(x => x === null || x === '')) {
                setErrorsConfirmAccount((currentState) => ({
                    ...currentState,
                    confirmAccountErrors: ["Por favor ingrese el código de confirmación"]
                }))

                return;
            } else {
                setErrorsConfirmAccount((currentState) => ({
                    ...currentState,
                    confirmAccountErrors: []
                }))
            }

            await ServicePatient.confirmAccount({
                uswEmail: valuesFormRegister['uswEmail'],
                codigoConfirmacion: Object.values(confirmAccount).join("")
            });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Su cuenta ha sido confirmada correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            setTimeout(() => {
                //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`);
                navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`);
            }, 500);

            handleCompletedStep();

        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false);
        }
    }

    const handleClickSendEmail = async () => {
        setLoading(true);
        try {
            const patientSchema = new PatientSchema();
            const emailValidate = await patientSchema.isValidSchema({ uswEmail: valuesFormRegister['uswEmail'] }, true);

            if (emailValidate.ok === false) {
                setErrorsFormRegister((currentState) => ({
                    ...currentState,
                    ...emailValidate.dataErrors
                }));

                return;
            }

            await ServicePatient.requestResetPassword({ uswEmail: valuesFormRegister['uswEmail'] });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Se ha enviado un correo electrónico",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            handleNextStepResetPassword();
        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false);
        }
    }

    const handleClickPasswordTemporal = async () => {
        setLoading(true);
        try {
            if (valuesFormRegister['claveTemporal'] === null || valuesFormRegister['claveTemporal'] === '') {
                setErrorsFormRegister((currentState) => ({
                    ...currentState,
                    claveTemporal: ["La clave temporal es requerida"]
                }));

                return;
            }

            await ServicePatient.verifyPasswordTemporal({
                uswEmail: valuesFormRegister['uswEmail'],
                claveTemporal: valuesFormRegister['claveTemporal']
            });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "La clave temporal ha sido verificada correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            handleNextStepResetPassword()

        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false);
        }
    }

    const handleClickResetPassword = async () => {
        setLoading(true);
        try {
            if (!handleValidatePasswordsMatch()) return;

            await ServicePatient.resetPassword({
                uswEmail: valuesFormRegister['uswEmail'],
                claveTemporal: valuesFormRegister['claveTemporal'],
                uswClave: valuesFormRegister['uswClave'],
                uswRepetirClave: valuesFormRegister['uswRepetirClave']
            });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Su clave ha sido reestablecida correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            handleCompletedStepResetPassword()

            setTimeout(() => {
                //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`);
                navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`);
            }, 500);
        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false);
        }
    }

    const handleClickResetPasswordProfile = async () => {
        setLoading(true);
        try {
            if (!handleValidatePasswordsMatch()) return;

            await ServicePatient.resetPasswordProfile({
                uswEmail: valuesFormRegister['uswEmail'],
                uswClave: valuesFormRegister['uswClave'],
                uswRepetirClave: valuesFormRegister['uswRepetirClave']
            });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Su clave ha sido reestablecida correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });
        } catch (error) {
            catchErrorApi(error)
        } finally {
            resetrulesPassword();
            setValuesFormRegister({
                ...valuesFormRegister,
                uswClave: '',
                uswRepetirClave: ''
            })
            setLoading(false);
        }
    }

    const handleClickSendEmailDelete = async () => {
        setLoading(true);
        try {
            const patientSchema = new PatientSchema();
            const emailValidate = await patientSchema.isValidSchema({ uswEmail: valuesFormRegister['uswEmail'] }, true);

            if (emailValidate.ok === false) {
                setErrorsFormRegister((currentState) => ({
                    ...currentState,
                    ...emailValidate.dataErrors
                }));
                return;
            }

            const existsEmail = true //await ServicePatient.existsUser({ uswEmail: valuesFormRegister['uswEmail'] });
            
            if (!existsEmail) {
                setErrorsFormRegister((currentState) => ({
                    ...currentState,
                    uswEmail: ["El correo electrónico no está registrado"]
                }))
                setSnackbar({
                    openAlert: true,
                    severity: "error",
                    text: "El correo electrónico no está registrado",
                    position: {
                        vertical: 'bottom',
                        horizontal: 'right'
                    }
                });  
            }
            else{
                handleNextStepEmailDelete();
            }
        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false);
        }
    }

    const handleClickConfirmSendEmailDelete = async () => {
        setLoading(true);
        try {
            await ServicePatient.sendCodeDeleteConfirmation({ uswEmail: valuesFormRegister['uswEmail'] });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Se ha enviado un correo electrónico",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            handleNextStepEmailDelete()
        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false);
        }
    }

    const handleClickDeleteUser = async () => {
        setLoading(true);
        try {
            if (Object.values(confirmAccount).some(x => x === null || x === '')) {
                setErrorsConfirmAccount((currentState) => ({
                    ...currentState,
                    confirmAccountErrors: ["Por favor ingrese el código de confirmación"]
                }))
                return;
            } else {
                setErrorsConfirmAccount((currentState) => ({
                    ...currentState,
                    confirmAccountErrors: []
                }))
            }

            await ServicePatient.deleteUser({
                uswEmail: valuesFormRegister['uswEmail'],
                codigoConfirmacion: Object.values(confirmAccount).join("")
            });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Su cuenta ha sido eliminada correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            setTimeout(() => {
                //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/eliminar`);
                navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/eliminar`);
            }, 500);
        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false);
        }
    }

    return {
        handleChange,
        handleClickCompleteInformation,
        handleClickSavePatient,
        handleClickConfirmAccount,
        handleBackStep,
        handleValidatePasswordsMatch,
        handleClickSendEmail,
        handleClickSendEmailDelete,
        handleClickConfirmSendEmailDelete,
        handleNextStepEmailDelete,
        handleCancelUserDelete,
        handleBackStepEmailDelete,
        handleClickPasswordTemporal,
        handleClickDeleteUser,
        handleClickResetPassword,
        handleClickResetPasswordProfile,
        handleValidatePhones,
        handleClickEditPatient,
        handleResendCodeConfirmation,
        handleValidateEmails,
        loading
    }
}

export default useSavePatient;